import React from 'react'

import { CoverStyled } from './styles'

export interface CoverProps {
  src: string
  srcMobile: string
  children?: JSX.Element
}
/**
 * Props
 * @param {string} src {string} - путь к изображению;
 * @param {string} srcMobile {string} - путь к мобильному изображению;
 * @param {JSX.Element} children {JSX.Element} - children;
 */

const Cover: React.FC<CoverProps> = ({ src, srcMobile, children }) => {
  //
  return (
    <CoverStyled>
      <svg
        className="desktop"
        width="100vw"
        height="54.166vw"
        viewBox="0 0 1440 780"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M161.094 743H141L217.906 574H238L161.094 743Z" fill="#E63C24" />
        <path d="M47 0H1440V780L1014.5 724.5L986.5 774L404.5 706L375 644L78.8672 611.394L47 0Z" fill="#67DBCA" />
        <mask id="mask-cover" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1440" height="704">
          <path d="M0 0H1440V479L1315 704L0 553V0Z" fill="black" />
        </mask>
        <g mask="url(#mask-cover)">
          <image width="1440" height="704" href={src} />
        </g>
        <path d="M113.094 695H93L169.906 526H190L113.094 695Z" fill="#E63C24" />
      </svg>

      <svg
        className="mobile"
        width="100vw"
        height="92vw"
        viewBox="0 0 375 345"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M41.9517 334.708H36.7188L56.7462 290.698H61.9792L41.9517 334.708Z" fill="#E63C24" />
        <path d="M12.5504 142H375V344.344L20.5384 300.436L12.5504 142Z" fill="#67DBCA" />
        <mask id="mask-cover-mobile" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="375" height="375">
          <path d="M0 0H375V265.958L342.448 324.552L0 285.229V0Z" fill="#67DBCA" />
        </mask>
        <g mask="url(#mask-cover-mobile)">
          <image width="375" height="375" href={srcMobile} preserveAspectRatio="xMidYMid slice" />
        </g>
        <path d="M29.4517 322.208H24.2188L44.2462 278.198H49.4792L29.4517 322.208Z" fill="#E63C24" />
      </svg>
      {children}
    </CoverStyled>
  )
}

export default Cover
